/**
 * @desc 更换库位标签
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.StockChangeLabelRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/pda/changeStockLabel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
